module.exports = __webpack_public_path__ + "img/simiaroom-instagram.4d72a77e.jpg";